<template>
  <!-- <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div> -->
  <form @submit.prevent="handleFilters">
    <div class="row filter-row mb-3">
      <div class="col-sm-6 col-md-3">
        <div class="input-block mt-1 mb-0">
          <label class="filter-label">Direct Manager</label>
          <input
            type="text"
            :style="`${
              filters.search && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'
            }`"
            class="form-control filter-input"
            v-model="filters.search"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-3">
        <div
          class="input-block mt-1 mb-0"
        >
          <label class="filter-label">Employee Name</label>
          <input
            type="text"
            :style="`${
              filters.employee_name && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'
            }`"
            class="form-control filter-input"
            v-model="filters.employee_name"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-3">
        <div
          class="input-block mt-1 mb-0"
        >
          <label class="filter-label">Employee ID</label>
          <input
            type="text"
            :style="`${
              filters.employee_id && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'
            }`"
            class="form-control filter-input"
            v-model="filters.employee_id"
          />
        </div>
      </div>
      <div class="d-flex align-items-end col-sm-6 col-md-3 gap-2 mt-1">
        <button
          type="submit"
          class="btn btn-filter"
          @click.prevent="handleFilters"
        >
          <i class="fa-solid fa-filter me-1"></i> Search
        </button>
        <button
          type="button"
          class="btn btn-reset"
          @click.prevent="resetAllFilters"
        >
          <i class="fa-solid fa-rotate-left me-1"></i> Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      filters: {
        search: "",
        employee_name: "",
        employee_id: "",
      },
      searched: false,
    };
  },
  props: {},
  methods: {
    handleFilters() {
      this.searched = true;
      this.$emit("apply-filters", this.filters);
    },

    resetAllFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      this.$emit("apply-filters", this.filters);

      this.searched = false;
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        search: "",
        employee_name: "",
        employee_id: "",
      };
      this.searched = false;
    },
  },
  async created() {
    this.searched = false;
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el,
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>

<style scoped>
.filter-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #878787;
  margin: 0 0 4px;
  padding: 0;
}

:deep(.filter-input) {
  height: 36px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  font-size: 12.5px;
  padding: 6px 12px;
  transition: all 0.2s ease;
}

:deep(.filter-input:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 10%, transparent);
}

.btn-filter {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
  color: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-filter:hover {
  background-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  border-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  color: #ffffff;
}

.btn-reset {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  color: #606266;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-reset:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
  color: #303133;
}
</style>
